/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TierEntitlementType } from './TierEntitlementType';
import {
    TierEntitlementTypeFromJSON,
    TierEntitlementTypeFromJSONTyped,
    TierEntitlementTypeToJSON,
    TierEntitlementTypeToJSONTyped,
} from './TierEntitlementType';

/**
 * 
 * @export
 * @interface TierEntitlement
 */
export interface TierEntitlement {
    /**
     * 
     * @type {TierEntitlementType}
     * @memberof TierEntitlement
     */
    type: TierEntitlementType;
    /**
     * Used for XP_MULTIPLIER and STREAK_BOOST types.
     * @type {number}
     * @memberof TierEntitlement
     */
    multiplier?: number;
    /**
     * Used for FEATURE_ACCESS type. e.g. "LEVEL_4_ACCESS"
     * @type {string}
     * @memberof TierEntitlement
     */
    feature?: string;
    /**
     * Used for STREAK_FREEZES type. Missed days a month protected; refilled with each monthly drop, never stacked.
     * @type {number}
     * @memberof TierEntitlement
     */
    amount?: number;
    /**
     * How this perk is worded to a player on the membership page, e.g. "XP on everything you play". An entitlement with no label is not shown.
     * @type {string}
     * @memberof TierEntitlement
     */
    label?: string;
}



/**
 * Check if a given object implements the TierEntitlement interface.
 */
export function instanceOfTierEntitlement(value: object): value is TierEntitlement {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function TierEntitlementFromJSON(json: any): TierEntitlement {
    return TierEntitlementFromJSONTyped(json, false);
}

export function TierEntitlementFromJSONTyped(json: any, ignoreDiscriminator: boolean): TierEntitlement {
    if (json == null) {
        return json;
    }
    return {
        
        'type': TierEntitlementTypeFromJSON(json['type']),
        'multiplier': json['multiplier'] == null ? undefined : json['multiplier'],
        'feature': json['feature'] == null ? undefined : json['feature'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function TierEntitlementToJSON(json: any): TierEntitlement {
    return TierEntitlementToJSONTyped(json, false);
}

export function TierEntitlementToJSONTyped(value?: TierEntitlement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': TierEntitlementTypeToJSON(value['type']),
        'multiplier': value['multiplier'],
        'feature': value['feature'],
        'amount': value['amount'],
        'label': value['label'],
    };
}

